import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { User } from '../../../shared/models/user';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-documents-download-button',
    templateUrl: './documents-download-button.component.html',
    styleUrls: ['./documents-download-button.component.scss'],
    standalone: false
})
export class DocumentsDownloadButtonComponent {

  @Input() loading = false;
  @Input() user: User;
  @Input() documentTitle: string;
  @Input() numberOfSelectedDocuments: number;

  @Output() downloadSelectedDocuments = new EventEmitter<User>();

  downloadDocuments() {
    this.downloadSelectedDocuments.emit(this.user);
  }

}
